import { getCookie } from 'cookies-next'
import { distinctIdCookieKey } from '../../cookie-keys'
import type { OptionsType } from 'cookies-next/lib/types'

export function _getDistinctIdCookie(options: OptionsType) {
  return getCookie(distinctIdCookieKey, options)
}
